import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { DataContext } from '../../Context/DataContext'
import { UIContext } from '../../Context/UIContext'

function MenuButton({ whitemode }) {
    const { menuOpen, setMenuOpen } = useContext(UIContext)
    const { strings } = useContext(DataContext)

    const handleMenuButton = (e) => {
        e.preventDefault()
        setMenuOpen(prevMenuOpen => !prevMenuOpen)
    }
    return (
        <motion.button
            className={`mga-button${menuOpen ? ' mga-button--active' : ''}${whitemode ? ' mga-button--light' : ''}`}
            onClick={handleMenuButton}
            aria-label={strings.menu}
        >
            <div className="mga-button__burger">{ strings.menu }</div>
        </motion.button>
    )
}

export default MenuButton